import React, { useEffect } from 'react';

import { IAccordionProps, Accordion } from '../Accordion';
import { FCWithChildren } from '@wix/challenges-web-library';
import { useCSSPBEnabled } from '../../hooks/useCSSPBStyle';
import { st, classes } from './SectionsAsTilesAccordion.st.css';

export interface ISectionsAccordionProps extends IAccordionProps {
  id?: string;
  emptyChildren?: boolean;
  lastItem?: boolean;
}

export const SectionsAsTilesAccordion: FCWithChildren<
  ISectionsAccordionProps
> = (props) => {
  const { title, id, className, opened, emptyChildren, ...rest } = props;
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const withCSSAlignment = useCSSPBEnabled({
    includeParticipantPageAlignmentCheck: true,
  });

  useEffect(() => {
    // only open by outside props
    if (opened) {
      setIsOpen(opened);
    }
  }, [opened]);

  return (
    <Accordion
      id={id}
      title={title}
      className={st(
        classes.root,
        {
          emptyChildren: props.emptyChildren,
          lastItem: props.lastItem,
        },
        className,
      )}
      onIconClick={() => {
        setIsOpen(!isOpen);
      }}
      opened={isOpen || props.opened}
      {...rest}
      withCSSAlignment={withCSSAlignment}
    >
      {props.children}
    </Accordion>
  );
};
